import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { api, errMsg } from "@/lib/api";
import { useSession } from "@/context/SessionContext";

export default function SsoLaunch() {
  const [params] = useSearchParams();
  const { signIn } = useSession();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const lt = params.get("lt");
    window.history.replaceState({}, document.title, "/sso/launch");
    if (!lt) {
      setError("This link is missing its launch token. Open Morr Translate from Morr Access.");
      return;
    }
    api.post("/sso/consume", { lt })
      .then((r) => {
        const { token, ...ctx } = r.data;
        signIn(token, ctx);
        navigate("/", { replace: true });
      })
      .catch((e) => setError(errMsg(e)));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen grid place-items-center grid-paper p-6">
      <div className="bg-white border border-slate-200 rounded-lg p-8 max-w-md w-full" data-testid="sso-launch-status">
        <div className="font-mono text-xs text-slate-500 mb-2">MORR ACCESS · SIGN IN</div>
        {error ? (
          <>
            <p className="text-red-700 text-sm" data-testid="sso-launch-error">{error}</p>
            <a href="/login" className="text-sm text-blue-600 underline mt-4 inline-block" data-testid="sso-back-to-login">Back to sign in</a>
          </>
        ) : (
          <p className="text-sm text-slate-700">Signing you in…</p>
        )}
      </div>
    </div>
  );
}
